(function($){
$(document).ready(function() {

    $(".lien-ressource").on('click', function(e){
        e.preventDefault();
        var id  = $(this).data('ressource'),
            url = $(this).data('url');

        let params = {
            id: id
        }
        $.ajax({
            // url: 'inc/xhr/actions.php?action=lien_ressource&id='+id,
            url: '/xhr-actions/lien_ressource',
            data: params,
            success: function(data) {
                window.open(url);
            }
        });
    });


    $(".voir-video").on('click', function(e){
        e.preventDefault();
        var id = $(this).data('video');

        let params = {
            id: id
        }
        $.ajax({
            // url: 'inc/xhr/actions.php?action=afficher_video&id='+id,
            url: '/xhr-actions/afficher_video',
            data: params,
            success: function(data) {
                ouvre_popin(data);
            }
        });
    });


    $('.menu-pages-fiches li').on( 'click', function(e) {
        e.preventDefault();
        var nextPrevUrl = $(this).data('link');
        if (nextPrevUrl != "")
            window.location.href=nextPrevUrl;
    });

    $("#enrefval").click(function(e){
        e.preventDefault();
        $("#formref").submit();
    });

    $('.row-content .paragraphe a').each(function(){
        let url = $(this).attr('href');
        if (typeof(url) != "undefined" && (url.substr(-4) == ".jpg" || url.substr(-5) == ".jpeg" || url.substr(-4) == ".gif" || url.substr(-4) == ".png"))
          $(this).addClass('lightbox');
    });

    $.widget( "custom.iconselectmenu", $.ui.selectmenu, {
        _renderItem: function( ul, item ) {
            var li = $( "<li>", { text: item.label } );
            var span = $( "<span>", {
                "class": "ui-icon " + "icon-"+item.value
            });
            if (item.value != "" && item.element[0].parentElement.id=="sel_type_doc")
                span.prependTo( li );

            return li.appendTo( ul );
        }
    });
    $.widget( "custom.navpages", $.ui.selectmenu, {
        _renderItem: function( ul, item ) {
            var li = $( "<li>", { text: item.label } );

            if ( item.index==0 && !$('body').hasClass('niv1id-5')){
                li.addClass( "first" );
            }

            if ( item.element.attr("selected")=="selected"){
                li.addClass( "current" );
            }

            var link = $("<a>",{
                "href": item.value,
                "class": "menu_link"
            })
            li.wrapInner(link);
            return li.appendTo( ul );
        },
    });

    function mediaqueryresponse(mql){
        if (/\(max-width:\s*767px\)/.test(mql.media)){
            if (mql.matches){
                $("#sel-nav-pages").navpages({
                    change: function( event, ui ) {
                        eval("parent.location='"+ui.item.value+"'");
                    }
                }).navpages( "menuWidget" );
                stickymenu.sticky('update');
            }
            else{
                $(".col-main").height('auto');
                stickymenu.sticky('update');
            }
        }
        else if (/\(max-width:\s*979px\)\s*and\s*\(min-width:\s*768px\)/.test(mql.media)){
            if (mql.matches){
                if ($(".col-main").height() < $(".col-infos").height())
                    $(".col-main").css("min-height", $(".col-infos").height()+"px");
                stickymenu.sticky('update');
                $("#sel-nav-pages").navpages({
                    change: function( event, ui ) {
                        eval("parent.location='"+ui.item.value+"'");
                    }
                }).navpages( "menuWidget" );
            }
            else{
                stickymenu.sticky('update');
            }
        }
        else if (/\(min-width:\s*980px\)/.test(mql.media)){
            if (mql.matches){
                if ($("#sel-nav-pages").navpages("instance") != undefined)
                    $("#sel-nav-pages").navpages("destroy");
                stickymenu.sticky('update');
            }
            else{
                stickymenu.sticky('update');
                $(".col-main").height('auto');

                $('.menu_link').on('click', function(e){
                    if ($(this).siblings('.submenu').length > 0){
                        e.preventDefault();
                        $(this).parent().siblings().removeClass('open');
                        $(this).parent().toggleClass('open');
                    }
                });
            }
        }
    }

    var stickymenu = $("body:not(.admin) #site-header"),
        mqMobile = 'only screen and (max-width: 767px)',
        mqTablette = 'only screen and (max-width: 979px) and (min-width: 768px)',
        mqOrdi = 'only screen and (min-width: 980px)',
        mqliste = [ // list of window.matchMedia() queries
            window.matchMedia(mqMobile),
            window.matchMedia(mqTablette),
            window.matchMedia(mqOrdi)
        ];
    for (var i=0; i<mqliste.length; i++){
        mediaqueryresponse(mqliste[i])
        mqliste[i].addListener(mediaqueryresponse)
    }
    stickymenu.sticky({zIndex: 1000});

    var stickyoutils = $('.menu-outils');
    stickyoutils.sticky({
        topSpacing: 120,
        wrapperClassName: 'menu-outils-sticky-wrapper'
    });


    $('.menu_item').on('mouseover', function(){
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
    });
    $('.menu_item').on('mouseout', function(){
        $(this).removeClass('hover');
    });

    $('#menu, .submenu_link').on('click', function(e){
        e.stopPropagation();
    });

    $(".paragraphe img").each(function () {
        align = $(this).css("float");
        if (align=="right"){
             $(this).css("margin-right","0");
             $(this).css("padding-left","15px");
        }
        if (align=="left"){
             $(this).css("margin-left","0");
             $(this).css("padding-right","15px");
        }
    });

    $(".page-content table").each(function () {
        border = $(this).attr("border");
        if ( border > 0 ) {
            $(this).attr("border", 0);
            $(this).addClass("tableborder");
        }
    });

    $('.menu-liste-carte a[role="tab"]').on('click', function(e){
        fermer_popin();
        $('#ja-carte').removeClass('heightzero');
    });
    $('.panel').hide();
    $('.panel.first').show();

    $('a[role="tab"]').on('click', function(e){
        e.preventDefault();
        mon_parent = $(this).parents("ul");
        mes_tabs = mon_parent.find('a[role="tab"]');
        mes_panneaux = mon_parent.siblings('[role="panel"]');

        target = $(this).attr('aria-controls');

        mes_tabs.attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");

        mes_panneaux.hide();
        $('#'+target).show();
    });

    $(".ajoutCriteres").on('click', function(e){
        type = $(this).data('type');
        $.ajax({url: 'inc/xhr/actions.php?action=ajouter_criteres&type='+type,
            success: function(data) {
                ouvre_popin(data);
            }
        })
    });


    $('.check-box-extra-users').on('click', function(e){
        action = $(this).data('action');
        id = $(this).data('iduser');
        $.ajax({url: 'inc/xhr/actions.php?action=selection_liste&champ_selection=users_extranet_email&valeur='+id})
    });

    $("#envoyer_mail_utilisateur_projets").on('click', function(e){
        $.ajax({url: 'inc/xhr/actions.php?action=envoyer_email_extranaute',
            success: function(data) {
                ouvre_popin(data);
            }
        })
    });


    $('.aide-projets').click(function(e){
        e.preventDefault();
        $.ajax({url: 'inc/xhr/actions.php?action=aide_projets',
            success: function(data) {
                ouvre_popin(data);
            }
        })
    });

    $('.participants-projets').click(function(e){
        e.preventDefault();
        $.ajax({url: 'inc/xhr/actions.php?action=participants_projets',
            success: function(data) {
                ouvre_popin(data);
            }
        })
    });

    $('.liste-doc-projet a').on('click', function(e){
        action = $(this).data('action');
        if (action != undefined) {
            e.preventDefault();
            type = $(this).data('type');
            url = $(this).data('url');
            name = $(this).data('name');
            parent = $(this).closest( ".LiensDocsProjet" );
            id = parent.data('iditem');
            if (action=="ajouter") {
                //
                // ajout d'un sous-dossier / doc/ lien
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=ajouter_dossier_fichier_lien&type='+type+'&id_parent='+id,
                    success: function(data) {
                            ouvre_popin(data);
                        }
                    });
                }
            if (action=="ouvrir_fermer") {
                //
                // ouvrir / fermer un dossier
                //
                lien_ouvrir_fermer = $(this);
                $(".col-main").height('auto');
                $("#liste-doc-projet"+id).slideToggle(200, function() {
                    if ($(".col-main").height() < $(".col-infos").height())
                        $(".col-main").height($(".col-infos").height());}
                    );
                $.ajax({url: "inc/xhr/actions.php?action=ouvrir_dossier&id="+id});
                lien_ouvrir_fermer.toggleClass("ouvert");
                }

            if (action=="afficher_infos") {
                //
                // renommer un sous-dossier / doc/ lien
                //
                parent.toggleClass("expand");
                }

            if (action=="renommer") {
                //
                // renommer un sous-dossier / doc/ lien
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=renommer&id='+id,
                    success: function(data) {
                            ouvre_popin(data);
                        }
                    });
                }
            if (action=="modifier") {
                //
                // modifier un lien
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=modifier_lien&id='+id,
                    success: function(data) {
                            ouvre_popin(data);
                        }
                    });
                }
            if (action=="deplacer") {
                //
                // deplacer un sous-dossier / doc/ lien
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=deplacer&id='+id,
                    success: function(data) {
                            ouvre_popin(data);
                        }
                    });
                }
            if (action=="remplacer") {
                //
                // renommer un sous-dossier / doc/ lien
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=remplacer&id='+id,
                    success: function(data) {
                            ouvre_popin(data);
                        }
                    });
                }
            if (action=="supprimer") {
                //
                // supprimer un sous-dossier / doc/ lien
                //
                if (type=="fichier")
                    alerte = "Êtes-vous certin(e) de vouloir supprimer le fichier "+name+" ?";
                if (type=="dossier")
                    alerte = "Êtes-vous certin(e) de vouloir supprimer le dossier "+name+" et tout son contenu ?";
                if (type=="lien")
                    alerte = "Êtes-vous certin(e) de vouloir supprimer le lien "+name+" ?";
                if (confirm(alerte)) {
                    $.ajax({
                        url: 'inc/xhr/actions.php?action=supprimer_projet_doc&id='+id,
                        success: function(data) {
                            window.location.reload();

                            //ouvre_popin(data);
                            }
                        });
                    }
                }
            if (action=="telecharger") {
                //
                // télécharger un sous-dossier
                //
                $.ajax({
                    url: 'inc/xhr/actions.php?action=supprimer_projet_doc&id='+id,
                    success: function(data) {
                        window.location.reload();

                        //ouvre_popin(data);
                        }
                    });
                }
            }
    });


    $("#lien_form_adhesion").on('click', function(){
        formulaire_adhesion();
    });


    $('.choix_adhesion').on('click', function(e){
        $('.choix_adhesion').prop( "checked", false );
        $(this).prop( "checked", true );
    });


}); // document.ready
})(jQuery);
